import * as GC from '@grapecity/spread-sheets';

// update getvalidListImp to display list of values in formula condition
const oldFn = (GC.Spread.Sheets.ConditionalFormatting.Condition as any).prototype.getValidListImp;
(GC.Spread.Sheets.ConditionalFormatting.Condition as any).prototype.getValidListImp = function() {
  if (this._useExpectedAsList) {
    return (this.expected() || '').split(',').map(val => ({
      text: val,
      value: val
    }));
  } else {
    return oldFn.apply(this, arguments);
  }
};
// update toJSON/fromJSON for our change to be serialized when using workbook.toJSON()/workbook.fromJSON()

const oldToJSON = (GC.Spread.Sheets.ConditionalFormatting.Condition as any).prototype.toJSON;
(GC.Spread.Sheets.ConditionalFormatting.Condition as any).prototype.toJSON = function() {
  const json = oldToJSON.apply(this, arguments);
  if (this._useExpectedAsList) {
    json['_useExpectedAsList'] = true;
  }
  return json;
};
const oldFromJSON = (GC.Spread.Sheets.ConditionalFormatting.Condition as any).prototype.fromJSON;
(GC.Spread.Sheets.ConditionalFormatting.Condition as any).prototype.fromJSON = function(settings) {
  if (!settings) {
    return;
  }
  oldFromJSON.apply(this, arguments);
  if (settings._useExpectedAsList) {
    this['_useExpectedAsList'] = true;
  }
};

// const spread = new GC.Spread.Sheets.Workbook(document.getElementById('ss'));
// initSpread(spread);

// function initSpread(spread) {
//   const sheet = spread.getActiveSheet();
//   spread.options.highlightInvalidData = true;

//   // create formula validator
//   const dv = GC.Spread.Sheets.DataValidation.createFormulaValidator('=ISNUMBER(INDIRECT(ADDRESS(ROW(), COLUMN(), 4)))');
//   // enable dropdown
//   dv.inCellDropdown(true);
//   dv.inputTitle('Please choose a category:');
//   dv.inputMessage('only number types allowed according to formula validator');
//   dv.type(GC.Spread.Sheets.DataValidation.CriteriaType.list);
//   // modify condition to display list
//   const con = dv.condition();
//   con.expected('1,2,3,a,b');
//   con._useExpectedAsList = true; // our custom flag, understood by our custom implementation of getValidListImp
//   // set validator
//   sheet.setDataValidator(1, 1, dv);
//   sheet.setValue(1, 1, 'invalid value');
// }
